<form class="form-vertical"
      id="parkingAdministrationEditForm"
      [formGroup]="parkingForm"
      autocomplete="off">
  <div class="form-row row">
    <div class="form-group">
      <label for="name"
             class="control-label">{{'i18n.shared.fields.name' | translate}}</label>
      <input type="text"
             id="name"
             class="form-control e-textbox"
             formControlName="name"
             name="name"
             autocomplete="off">
      <app-error-messages [control]="parkingForm.controls.name"></app-error-messages>
    </div>
  </div>

  <div class="form-row row">
    <div class="form-group">
      <label>{{ 'i18n.domain.parking.client' | translate }}</label>
      <ejs-dropdownlist [fields]="clientDropdownSettings"
                        formControlName="clientId"
                        id="clientId"
                        (change)="resetZone($event)"
                        [dataSource]="clientDropdownValues"></ejs-dropdownlist>
    </div>
  </div>

  @if (clientSelected) {
    <div class="form-row row">
      <div class="form-group">
        <label>{{ 'i18n.domain.parking.zone' | translate }}</label>
        <ejs-dropdownlist [fields]="clientDropdownSettings"
                          formControlName="zoneId"
                          id="zoneId"
                          (change)="resetSubscription($event)"
                          [dataSource]="zoneDropdownValues">
          <ng-template #valueTemplate
                      let-data>
            @if (data?.name.length) {
              <div class="line-height">
                @for (zone of data.name; track zone; let last = $last) {
                  <span
                        [ngClass]="{'fw-bold': last}"
                        class="slash-separated">{{zone}}</span>
                }
              </div>
            }
          </ng-template>
          <ng-template #itemTemplate let-data>
            @if (data?.name.length) {
              @for (zone of data.name; track zone; let last = $last) {
                <span
                        [ngClass]="{'fw-bold': last}"
                        class="slash-separated">{{zone}}</span>
              }
            }
          </ng-template>
        </ejs-dropdownlist>
      </div>
    </div>
  }

  @if (zoneSelected) {
    <div class="form-row row">
      <div class="form-group">
        <label>{{ 'i18n.domain.parking.subscription' | translate }}</label>
        <ejs-dropdownlist [fields]="clientDropdownSettings"
                          formControlName="subscriptionAssignmentId"
                          id="subscriptionAssignmentId"
                          (change)="resetWeekdays($event)"
                          [dataSource]="subscriptionsDropdownValues"></ejs-dropdownlist>
      </div>
    </div>
  }

  @if (zoneSelected && parkingSpaceNumberDefinition != null) {
    <div class="form-row row">
      <div class="form-group">
        <label for="parkingSpaceNumber">{{ 'i18n.domain.parking.parkingSpaceNumber' | translate }}</label>
        <input type="text" class="form-control"
                          formControlName="parkingSpaceNumber"
                          id="parkingSpaceNumber"
                          name="parkingSpaceNumber"
                          autocomplete="off"/>
      </div>
    </div>
  }

  @if (clientSelected) {
    <div class="form-row row">
      <div class="form-group">
        <label>{{ 'i18n.domain.parking.storedVehicle' | translate }}</label>
        <ejs-dropdownlist [fields]="clientDropdownSettings"
                          formControlName="controlPlateId"
                          id="controlPlateId"
                          [dataSource]="controlPlateDropdownValues"></ejs-dropdownlist>
      </div>
    </div>
  }

  @if (isSubscriptionSelected) {
    <div class="form-row row mt-2">
      <div class="form-group">
        <label>{{ 'i18n.domain.parking-administration.edit.validAt' | translate }}</label>
        <app-day-selector [form]="weekdaysFormGroup"></app-day-selector>
      </div>
    </div>
  }

  @if (parkingForm.controls.weekdays.valid) {
    <div class="form-row row mt-2">
      <div class="form-group">
        @if (hasPossibleStartTimeRanges) {
          <div>
            <app-time-picker-with-time-slider
                                            [form]="timePickerFormGroup"
                                            [maxDuration]="maxDuration"
                                            [timepickerStrictMode]="true"
                                            [showSliderBeforeTimeSelection]="false"
                                            [possibleStartTimeRanges]="possibleStartTimeRanges"
                                            (startTimeChange)="onStartTimeChange($event)"></app-time-picker-with-time-slider>

            @if (!parkingForm.controls.startTime.valid) {
              <div>
                <div>{{'i18n.domain.parking-administration.possible-time-ranges' | translate}}:</div>
                <div>
                  <table class="form-text-size">
                    @for (range of possibleStartTimeRanges; track range) {
                      <tr>
                        <td>{{range.startTimeStr}}</td>
                        <td class="window-delimiter">-</td>
                        <td>{{range.endTimeStr}}</td>
                        <td>{{range.possibleParkingEndTime}}</td>
                      </tr>
                    }
                  </table>
                </div>
              </div>
            }
          </div>
        } @else {
          {{'i18n.domain.parking-administration.no-overlapping-tariffs' | translate}}
        }
      </div>
    </div>
  }

  @if (isEdit) {
    <div class="form-row row">
      <div class="form-group col-md-12">
        <label class="d-block">{{'i18n.shared.fields.active' | translate}}</label>
        <app-yes-no-group-button id="isActive"
                                formControlName="isActive"></app-yes-no-group-button>
      </div>
    </div>
  }

  @if (overlappingSchedule) {
    <div class="row">
      <div class="col-12">
        <div class="alert alert-danger overlapping-schedule-alert">
          {{'i18n.domain.parking-administration.overlapping-schedule-error' | translate: {name: overlappingSchedule.name} }}
        </div>
      </div>
    </div>
  }
</form>
